import { IArrecadacaoError } from 'interfaces/IArrecadacaoError';

export function incluirSentryIdMsgErro(errorWithSentryID: IArrecadacaoError | undefined | null): string {
  if (errorWithSentryID?.response?.data?.sentryId) {
    return `Código do erro : ${errorWithSentryID.response.data.sentryId} .`;
  }
  return '';
}
